
import TableList from "@components/templates/tablelist";
import { HttpRevokeBilling,HttpNoNeedBilling,HttpGetbillPeriodList } from "@/service/newbigaccount";
import { HttpGetAccountList,HttpGetPaybillPeriodList } from "@/service/chargescalc";
import { HttpServiceWarehouseList } from "@/service/basicdata"
import { mapState, mapGetters } from "vuex";
import comLong from './longtext';
import comExcel from '../../excelalert.vue'
import mixin from '../../mixin'

export default {
    mixins: [TableList,mixin],
    components: {
        comLong,
        comExcel
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            formData:{
                search:{
                    EQ_status:null,
                    EQ_promotionType:null,
                    IN_id:null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            peroList:[],
        };
    },

    created() {
        this.revokeSymbal = this.handleAuth("fbb.billing.revokeBilling");
        this.noneedSymbal = this.handleAuth("fbb.billing.noNeedBilling");
        HttpGetPaybillPeriodList({
            page:1,
            rows:10000,
        }).then(res=>{
            this.peroList = res.data.content
        })
    },

    methods: {
        ajaxRequest: HttpGetAccountList,

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'promotionUpdate',
                        params: { type: "add"},
                        query: { sourceType: this.formData.search.EQ_type}
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'promotionUpdate',
                        params: { type: "edit"},
                        query: { id: params , sourceType: this.formData.search.EQ_type },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "long":
                    this.operate = {
                        title: '查看详情',
                        show:true,
                        width:460,
                        component: "comLong",
                        detailtext:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "revoke":
                    this.operate={
                        show: true,
                        alert: "warning",
                        params:{ids:params, operationObject:'BILLING_ORDER_ITEM', billingChannel: 'PAYABLE'},
                        title: "重新结算",
                        ajaxRequest:HttpRevokeBilling
                    }
                    break;
                case "noneed":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, operationObject:'BILLING_ORDER_ITEM', billingChannel:'PAYABLE'},
                        title: "无需结算",
                        ajaxRequest:HttpNoNeedBilling
                    }
                    break;
                case "export":
                    // this.handleWebfs(
                    //     process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billingPayableOrderItem/export", this.formData,
                    //     {
                    //         executor: "request",
                    //         download: true,
                    //         method: 'get'
                    //     }
                    // );
                    this.export();
                    break;
            }
        },
        export(){
            const {search}=this.formData
                // const orgWarehouseId = search.EQ_orgWarehouseCode ? this.getBillcusWareList.filter(item => item.attach.code === search.EQ_orgWarehouseCode)[0].value : `''`;
                const startAt = search.BT_createdAt ? search.BT_createdAt.slice(0,10) : `''`;
                const endAt = search.BT_createdAt ? search.BT_createdAt.slice(13) : `''`;
                const complete_start_at = search.BT_completeDate ? search.BT_completeDate.slice(0,10) : `''`;
                const complete_end_at = search.BT_completeDate ? search.BT_completeDate.slice(13) : `''`;
                const searchItem = {
                    isManage: 1,
                    type: 1,
                    context_id: global.SYSID,
                    organization_id: search.EQ_organizationId || `''`,
                    bill_no: search.EQ_billNo ? search.EQ_billNo.trim() : `''`,
                    order_type: search.EQ_orderType || `''`,
                    bill_period_id: search.EQ_billPeriodId || `''`,
                    order_no: search.EQ_orderNo || `''`,
                    org_warehouse_id: search.EQ_warehouseId || `''` ,
                    line_id: search.EQ_lineId || `''`,
                    billing_category_name_level: search.CN_billingCategoryNameLevel || `''`,
                    sku: search.CN_sku || `''`,
                    trade_no: search.EQ_tradeNo || `''`,
                    source_no: search.EQ_sourceNo || `''`,
                    expense_category_customize_code: search.CN_expenseCategoryCustomizeCode || `''`,
                    box_code: search.CN_boxCode || `''`,
                    complete_start_at: complete_start_at,
                    complete_end_at: complete_end_at,
                    start_at: startAt,
                    end_at: endAt,
                    bill_status: search.EQ_billStatus || `''`,
                }
                this.handleWebfs(
                    process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
                    {args:JSON.stringify(searchItem), template_id: 10016},
                    {
                        executor: "request",
                        download: true,
                        method: "post",
                    }
                )
                .then((res) => {
                    this.operate = {
                      title: '查询条件导出',
                      show: true,
                      width: 560,
                      component: "comExcel",
                      fileId: res.data.id,
                      showFooter: false
                }})
                .catch((err) => {
                    // this.$VMessage.error(err.message);
                });
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'删除',
                show: true,
                params:id,
                operate:'delete'
            }, ]
        },
    },
    computed: {
        ...mapGetters('dictionary',['getBillcusorgList','getBillcusWareList','getCusproductList','getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "primary",
                },
                {
                    name: "重新结算",
                    operate: "revoke",
                    show:this.revokeSymbal,
                    more:true,
                    batch:true,
                },
                {
                    name: "无需结算",
                    operate: "noneed",
                    show:this.noneedSymbal,
                    more:true,
                    batch:true,
                },
            ]

        },
        SearchsData() {
            let widthStyle = 'width: 200px;'
            // const dropStyle="width:auto;";
            return  [

                {
                    label: "客户组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'EQ_warehouseId',
                    options: this.warehouseList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '账单编号',
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    show: true,
                },
                {
                    label: 'SKU',
                    tag: 'vInput',
                    key: 'CN_sku',
                    style: widthStyle,
                },

                {
                    label: '账期',
                    tag: 'vSelect',
                    key: 'EQ_billPeriodId',
                    options: this.peroList.map(item=>{
                        return {
                            label:item.code,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    style: widthStyle,
                },
                // {
                //     label: '计费项',
                //     tag: 'vInput',
                //     key: 'EQ_billingCategoryNameLevel',
                // },
                {
                    label: '项目',
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    props:{
                        filterable:true,
                    },
                    style: widthStyle,
                },
                {
                    label: '单号',
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                    style: widthStyle,
                },
                {
                    label: '箱码',
                    tag: 'vInput',
                    key: 'CN_boxCode',
                    style: widthStyle,
                },
                {
                    label: '订单类型',
                    tag: 'vSelect',
                    key: 'EQ_orderType',
                    options: this.getOrderList,
                    props:{
                        filterable:true,
                    },
                    style: widthStyle,
                },
                {
                    label: '来源单号',
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    style: widthStyle,
                },
                {
                    label: '交易参考号',
                    tag: 'vInput',
                    key: 'EQ_tradeNo',
                    style: widthStyle,
                },
                {
                    label: '报价模板代码',
                    tag: 'vInput',
                    key: 'CN_expenseCategoryCustomizeCode',
                    style: widthStyle,
                },
                {
                    label: '计费项',
                    tag: 'vInput',
                    key: 'CN_billingCategoryNameLevel',
                    style: widthStyle,
                },
                {
                    label: '结算日期',
                    tag: 'vDatepicker',
                    key: 'BT_completeDate',
                    props:{
                        options: this.options,
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle,
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props:{
                        options: this.options,
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle,
                },
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '客户组织/仓库',
                    // render: (h, { row }) => this.findRenderLabel(this.getBillcusorgList, row.organizationId),
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.organizationName}</div>
                            <div>{this.findRenderLabel(this.warehouseList, row.warehouseId) || '--'}</div>
                        </div>
                    }
                },
                // {
                //     title: '仓库',
                //     width: 150,
                //     render: (h, { row }) => this.findRenderLabel(this.getBillcusWareList, row.warehouseId),
                // },
                {
                    title: '交易参考号',
                    render: (h, { row }) => {
                        return <div>{row.tradeNo || '--'}</div>
                    }
                },
                // {
                //     title: '账单编号',
                //     width: 150,
                //     render: (h, { row }) => {
                //         return <div>{row.billNo || '--'}</div>
                //     }
                // },
                {
                    title: '账单编号/账期',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.billNo || '--'}</div>
                            <div>{row.billPeriodCode || '--'}</div>
                        </div>

                    },
                },
                {
                    title: '报价模板代码/计费项',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.expenseCategoryCustomizeCode || '--'}({row.version})</div>
                            <div>{row.billingCategoryNameLevel || '--'}</div>
                        </div>
                    }
                },
                // {
                //     title: '计费项',
                //     width: 150,
                //     render: (h, { row }) => {
                //         return <div>{row.billingCategoryNameLevel || '--'}</div>
                //     }
                // },
                {
                    title: 'SKU/项目',
                    render: (h, { row }) => {
                        return <div >
                            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{row.sku || '--'}</div>
                                <a v-show={row.sku} onClick={this.handleOperates.bind(this, row.sku, 'long')}>点击查看详情</a>
                                <div>{row.lineName || '--'}</div>
                            </div>
                    }
                },
                {
                    title: '单价*数量*计费量',
                    render: (h, { row }) => {
                        return <div>{row.price || '--'}*{row.qty || '--'}*{row.quantum || '--'}</div>
                    }
                },
                {
                    title: '费用',
                    render: (h, { row }) => {
                        return <div>{row.totalCost || '--'}</div>
                    }
                },
                {
                    title: '订单类型/单号',
                    // render: (h, { row }) => {
                    //     return <div>{row.orderType || '--'}</div>
                    // }
                    render: (h, { row }) => {
                        return <div>
                            <div>{this.findRenderLabel(this.getOrderList, row.orderType) || '--'}</div>
                            <div>单号：{row.orderNo || '--'}</div>
                            <div>来源单号：{row.sourceNo || '--'}</div>
                            <div>箱码：{row.boxCode || '--'}</div>
                        </div>
                    }
                },
                // {
                //     title: '单号',
                //     width: 150,
                //     render: (h, { row }) => {
                //         return <div>
                //             <div>单号：{row.orderNo || '--'}</div>
                //             <div>来源单号：{row.sourceNo || '--'}</div>
                //             <div>箱码：{row.boxCode || '--'}</div>
                //         </div>
                //     }
                // },
                {
                    title: '备注',
                    render: (h, { row }) => {
                        return <div >
                            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{row.remark || '--'}</div>
                            <a v-show={row.remark} onClick={this.handleOperates.bind(this, row.remark, 'long')}>点击查看详情</a>
                        </div>
                    }
                },
                {
                    title: '结算时间/创建时间',
                    width: 150,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.completeDate || '--'}</div>
                            <div>{row.createdAt || '--'}</div>
                        </div>
                    }
                },
            ];
        },

    },

};
